<template>
<v-container class="ma-0 pa-0">
  <v-overlay absolute v-model="overlay.show">
    <v-progress-circular indeterminate size="100">
      {{overlay.text}}
    </v-progress-circular>
  </v-overlay>
</v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Overlay',

  computed: {
    ...mapState(['overlay'])
  }
}
</script>